import { Controller } from "@hotwired/stimulus";

// QCM builder used inside `_element_form.html.erb`. Manages a list of
// questions, each with its own answers. Persists the structure into a
// hidden `lesson_element[content]` field as JSON whenever it mutates.
//
// JSON shape (already used by the legacy code we replace):
//   [{ question: "…", answers: [{ text: "…", correct: true }, …] }, …]
export default class extends Controller {
  static targets = ["container", "field"];
  static values  = { initial: String };

  connect() {
    let parsed;
    try { parsed = JSON.parse(this.initialValue || "[]"); } catch (_e) { parsed = []; }
    this.questions = Array.isArray(parsed) ? parsed : [];
    if (this.questions.length === 0) this.questions = [this._blankQuestion()];
    this._render();
  }

  addQuestion() {
    this.questions.push(this._blankQuestion());
    this._render();
  }

  // Helpers --------------------------------------------------------------

  _blankQuestion() {
    return { question: "", answers: [{ text: "", correct: false }] };
  }

  _render() {
    if (!this.hasContainerTarget) return;
    this.containerTarget.innerHTML = "";
    this.questions.forEach((question, qIdx) => {
      const qWrap = document.createElement("div");
      qWrap.className = "lc-qcm-builder__question";
      qWrap.dataset.questionIndex = String(qIdx);

      // Header
      const head = document.createElement("div");
      head.className = "lc-qcm-builder__question-head";
      const label = document.createElement("span");
      label.textContent = `Question ${qIdx + 1}`;
      head.appendChild(label);

      const removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "lc-qcm-builder__remove";
      removeBtn.title = "Supprimer la question";
      removeBtn.innerHTML = '<i class="fa-solid fa-xmark"></i>';
      removeBtn.addEventListener("click", () => {
        this.questions.splice(qIdx, 1);
        if (this.questions.length === 0) this.questions = [this._blankQuestion()];
        this._render();
      });
      head.appendChild(removeBtn);
      qWrap.appendChild(head);

      // Question prompt
      const promptInput = document.createElement("input");
      promptInput.type = "text";
      promptInput.placeholder = "Énoncé de la question…";
      promptInput.value = question.question || "";
      promptInput.addEventListener("input", (e) => {
        this.questions[qIdx].question = e.target.value;
        this._sync();
      });
      qWrap.appendChild(promptInput);

      // Answers
      (question.answers || []).forEach((answer, aIdx) => {
        const aWrap = document.createElement("div");
        aWrap.className = "lc-qcm-builder__answer";

        const aInput = document.createElement("input");
        aInput.type = "text";
        aInput.placeholder = `Réponse ${aIdx + 1}`;
        aInput.value = answer.text || "";
        aInput.addEventListener("input", (e) => {
          this.questions[qIdx].answers[aIdx].text = e.target.value;
          this._sync();
        });
        aWrap.appendChild(aInput);

        const correctBtn = document.createElement("button");
        correctBtn.type = "button";
        correctBtn.className = `lc-qcm-builder__correct${answer.correct ? " is-correct" : ""}`;
        correctBtn.innerHTML = answer.correct
          ? '<i class="fa-solid fa-check"></i> Correcte'
          : '<i class="fa-solid fa-xmark"></i> Incorrecte';
        correctBtn.addEventListener("click", () => {
          this.questions[qIdx].answers[aIdx].correct = !this.questions[qIdx].answers[aIdx].correct;
          this._render();
        });
        aWrap.appendChild(correctBtn);

        const removeAnswer = document.createElement("button");
        removeAnswer.type = "button";
        removeAnswer.className = "lc-qcm-builder__remove";
        removeAnswer.title = "Supprimer la réponse";
        removeAnswer.innerHTML = '<i class="fa-solid fa-trash"></i>';
        removeAnswer.addEventListener("click", () => {
          this.questions[qIdx].answers.splice(aIdx, 1);
          if (this.questions[qIdx].answers.length === 0) {
            this.questions[qIdx].answers.push({ text: "", correct: false });
          }
          this._render();
        });
        aWrap.appendChild(removeAnswer);

        qWrap.appendChild(aWrap);
      });

      // Add answer
      const addAnswer = document.createElement("button");
      addAnswer.type = "button";
      addAnswer.className = "btn-ds btn-ds--ghost btn-ds--sm";
      addAnswer.style.alignSelf = "flex-start";
      addAnswer.innerHTML = '<i class="fa-solid fa-plus"></i> Ajouter une réponse';
      addAnswer.addEventListener("click", () => {
        this.questions[qIdx].answers.push({ text: "", correct: false });
        this._render();
      });
      qWrap.appendChild(addAnswer);

      this.containerTarget.appendChild(qWrap);
    });

    this._sync();
  }

  _sync() {
    if (this.hasFieldTarget) {
      this.fieldTarget.value = JSON.stringify(this.questions);
    }
  }
}
